;(function () {
  'use strict'

  angular
    .module('contrast.ip')
    .factory('IPBlacklistModalDeleteService', [
      '$uibModal',
      IPBlacklistModalDeleteService
    ])

  function IPBlacklistModalDeleteService($uibModal) {
    var service = {
      open: open
    }

    return service

    function open(address) {
      return $uibModal.open({
        templateUrl: 'views/rules/ip/modal_delete.html',
        controller: 'DeleteIPBlacklistCtrl',
        size: 'sm',
        resolve: {
          address: function () {
            return address
          }
        }
      }).result
    }
  }
})()
